export const createFlatListFromTree = (tree, list) => {
    for (let node of tree) {
        list.push({
            id: node.id,
            text: node.text,
            parentId: node.parentId
        });
        if (node.items && node.items.length > 0) {
            createFlatListFromTree(node.items, list);
        }
    }
    return list;
}

export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const getMaxExpandedLevel = (tree) => {
    let maxExpandedLevel = 0;
    for (let node of tree) {
        if (node.expandedLevel > maxExpandedLevel) {
            maxExpandedLevel = node.expandedLevel;
        }
        if (node.items && node.items.length > 0) {
            const childMaxExpandedLevel = getMaxExpandedLevel(node.items);
            if (childMaxExpandedLevel > maxExpandedLevel) {
                maxExpandedLevel = childMaxExpandedLevel;
            }
        }
    }
    return maxExpandedLevel;
};

export const getIdsForTreeData = (tree, ids, expandedLevel) => {
    if (expandedLevel === null) return [];
    for (let node of tree) {
        if (expandedLevel.includes(node.expandedLevel)) {
            ids.push(node.id);
        }
        if (node.items && node.items.length > 0) {
            getIdsForTreeData(node.items, ids, expandedLevel);
        }
    }
    return ids;
};

export const findElementInTree = (array, item) => {
    for (const node of array) {
        if (node.id === item.id) {
            return node;
        }

        if (node.items && node.items.length > 0) {
            const result = findElementInTree(node.items, item);
            if (result) {
                return result;
            }
        }
    }
    return null;
};

export const findElementByLevelIndex = (data, Levels) => {
    if (Levels.length === 0 || !Array.isArray(data)) {
        return null;
    }

    const index = Levels[0];

    if (index < 0 || index >= data.length) {
        return null;
    }

    const newData = data[index];

    if (Levels.length === 1) {
        return newData;
    }

    return findElementByLevelIndex(newData.items, Levels.slice(1));
};

export const CheckIfTreeIsSame = (tree, defaultTree) => {
    if (tree.length !== defaultTree.length) return false;

    const compareNodes = (node1, node2) => {
        if (node1.text.trim() !== node2.text.trim()) return false;

        if (node1.items.length !== node2.items.length) return false;

        for (let i = 0; i < node1.items.length; i++) {
            if (!compareNodes(node1.items[i], node2.items[i])) {
                return false;
            }
        }
        return true;
    };

    return compareNodes(tree[0], defaultTree[0]);
};

// TODO: Support translation for the following function
export const CheckErrorInTree = (tree) => {
    const FlatTree = createFlatListFromTree(tree, []);
    for (const node of FlatTree) {
        // check empty
        if (node.text.trim() === "") {
            return "all_fields_required";
        }
    }
    // check duplicate withing same level
    for (let i = 0; i < FlatTree.length; i++) {
        for (let j = i + 1; j < FlatTree.length; j++) {
            if (FlatTree[i].parentId === FlatTree[j].parentId && FlatTree[i].text.trim() === FlatTree[j].text.trim()) {
                return "duplicate_value";
            }
        }
    }
    return "";
}

export const removeExtraSpaceFromTreeElement = (tree) => {
    for (let node of tree) {
        node.text = node.text.trim();
        if (node.items && node.items.length > 0) {
            removeExtraSpaceFromTreeElement(node.items);
        }
    }
    return tree;
}